export default __webpack_public_path__ + "static/media/car.8a2b1ff5.svg";